<template>
  <div>
    <div class="row">
      <div class="col-xl-12">
        <b-overlay :show="isLoading" rounded="sm">
          <div class="card card-custom card-stretch gutter-b" id="page">
            <!--begin::Header-->
            <div class="card-header border-0">
              <h3 class="card-title font-weight-bolder text-dark">
                Détail de l'abonnement
              </h3>
              <div class="card-toolbar">
                <b-dropdown
                  size="sm"
                  variant="link"
                  toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                  no-caret
                  right
                  no-flip
                >
                  <template v-slot:button-content>
                    <i class="ki ki-bold-more-ver"></i>
                  </template>
                  <!--begin::Navigation-->
                  <div class="navi navi-hover" style="width: 250px">
                    <!-- <b-dropdown-text
                      tag="div"
                      class="navi-item"
                      @click="goToStateHistory(request.guid)"
                    >
                      <a href="javascript:;" class="navi-link">
                        <span class="navi-icon">
                          <i class="fas fa-landmark"></i>
                        </span>
                        <span class="navi-text">Historique</span>
                      </a>
                    </b-dropdown-text> -->

                    <b-dropdown-text
                      tag="div"
                      class="navi-item"
                      v-if="request.subscriptionState.state != 2"
                    >
                      <a
                        href="javascript:;"
                        class="navi-link"
                        @click="startSubscriptionActivation()"
                      >
                        <span class="navi-icon">
                          <i class="fas fa-calendar-check"></i>
                        </span>
                        <span class="navi-text">Activation</span>
                      </a>
                    </b-dropdown-text>
                    <b-dropdown-text
                      tag="div"
                      class="navi-item"
                      v-if="request.subscriptionState.state != 1"
                    >
                      <a
                        href="javascript:;"
                        class="navi-link"
                        @click="startChangeSubscriptionEndDate()"
                      >
                        <span class="navi-icon">
                          <i class="fas fa-edit"></i>
                        </span>
                        <span class="navi-text">Date de fin d'abonnement</span>
                      </a>
                    </b-dropdown-text>

                    <!-- <b-dropdown-text tag="div" class="navi-item">
                      <a
                        href="javascript:;"
                        class="navi-link"
                        v-b-modal.cancel-modal
                      >
                        <span class="navi-icon">
                          <i class="fas fa-times"></i>
                        </span>
                        <span class="navi-text">Annuler</span>
                      </a>
                    </b-dropdown-text> -->
                  </div>
                  <!--end::Navigation-->
                </b-dropdown>
              </div>
            </div>
            <!--end::Header-->
            <!--begin::Body-->
            <div class="card-body pt-2">
              <div class="row">
                <div class="col-xl-6">
                  <div class="d-flex flex-wrap align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                    ></div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3"
                    >
                      <div class="text-dark-75 font-weight-bolder font-size-lg">
                        Réference:
                      </div>
                    </div>
                    <!--end::Title-->
                    <!--begin::Info-->
                    <div class="d-flex align-items-center py-lg-0 py-2">
                      <div class="d-flex flex-column text-right">
                        <span
                          class="text-dark-75 font-weight-bolder font-size-h6"
                          >{{ request.reference }}</span
                        >
                      </div>
                    </div>
                    <!--end::Info-->
                  </div>
                  <div class="separator separator-dashed mt-2 mb-2"></div>
                  <div class="d-flex flex-wrap align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                    ></div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3"
                    >
                      <div class="text-dark-75 font-weight-bolder font-size-lg">
                        Etat:
                      </div>
                    </div>

                    <!--end::Title-->
                    <!--begin::Info-->
                    <div class="d-flex align-items-center py-lg-0 py-2">
                      <div class="d-flex flex-column text-right">
                        <span
                          class="label label-lg label-inline"
                          :class="
                            'label-light-' +
                              getRequestStateLable(
                                request.subscriptionState.state
                              ).color
                          "
                        >
                          {{ request.subscriptionState.label }}
                        </span>
                      </div>
                    </div>
                    <!--end::Info-->
                  </div>
                  <div class="separator separator-dashed mt-2 mb-2"></div>
                  <div class="d-flex flex-wrap align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                    ></div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3"
                    >
                      <div class="text-dark-75 font-weight-bolder font-size-lg">
                        Utilisateur:
                      </div>
                    </div>
                    <!--end::Title-->
                    <!--begin::Info-->
                    <div class="d-flex align-items-center py-lg-0 py-2">
                      <div class="d-flex flex-column text-right">
                        <a
                          href="javascript:;"
                          class="
                            text-dark-75
                            font-weight-bolder
                            text-hover-primary
                            font-size-h6
                          "
                          @click="goToClient(request.requestedBy.id)"
                        >
                          {{ request.requestedBy.userName }}</a
                        >
                        <span
                          class="text-muted font-weight-bolder font-size-sm"
                          >{{ request.requestedBy.phoneNumber }}</span
                        >
                      </div>
                    </div>
                    <!--end::Info-->
                  </div>

                  <div class="separator separator-dashed mt-2 mb-2"></div>
                  <div class="d-flex flex-wrap align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                    ></div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3"
                    >
                      <div class="text-dark-75 font-weight-bolder font-size-lg">
                        Service:
                      </div>
                    </div>
                    <!--end::Title-->
                    <!--begin::Info-->
                    <div class="d-flex align-items-center py-lg-0 py-2">
                      <div class="d-flex flex-column text-right">
                        <span
                          class="text-dark-75 font-weight-bolder font-size-h6"
                        >
                          {{ request.service.name }}
                        </span>
                      </div>
                    </div>
                    <!--end::Info-->
                  </div>

                  <div class="separator separator-dashed mt-2 mb-2"></div>
                  <div class="d-flex flex-wrap align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                    ></div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3"
                    >
                      <div class="text-dark-75 font-weight-bolder font-size-lg">
                        Pack:
                      </div>
                    </div>
                    <!--end::Title-->
                    <!--begin::Info-->
                    <div class="d-flex align-items-center py-lg-0 py-2">
                      <div class="d-flex flex-column text-right">
                        <span
                          class="text-dark-75 font-weight-bolder font-size-h6"
                        >
                          {{ request.subService.name }}
                        </span>
                      </div>
                    </div>
                    <!--end::Info-->
                  </div>

                  <div class="separator separator-dashed mt-2 mb-2"></div>
                  <div class="d-flex flex-wrap align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                    ></div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3"
                    >
                      <div class="text-dark-75 font-weight-bolder font-size-lg">
                        Type:
                      </div>
                    </div>
                    <!--end::Title-->
                    <!--begin::Info-->
                    <div class="d-flex align-items-center py-lg-0 py-2">
                      <div class="d-flex flex-column text-right">
                        <span
                          class="text-dark-75 font-weight-bolder font-size-h6"
                        >
                          {{ request.subscriptionType.label }}
                        </span>
                        <span
                          class="text-muted font-weight-bolder font-size-lg"
                          v-if="
                            request.subscriptionType.url 
                          "
                          >URL:
                          {{ request.subscriptionType.url }}</span
                        >
                        <span
                          class="text-muted font-weight-bolder font-size-lg"
                          v-if="
                            request.subscriptionType.userName &&
                              request.subscriptionType.type == 2
                          "
                          >Nom d'utilisateur:
                          {{ request.subscriptionType.userName }}</span
                        >
                        <span
                          class="text-muted font-weight-bolder font-size-lg"
                          v-if="
                            request.subscriptionType.password &&
                              request.subscriptionType.type == 2
                          "
                          >Mot de passe:
                          {{ request.subscriptionType.password }}</span
                        >
                        <span
                          class="text-muted font-weight-bolder font-size-lg"
                          v-if="request.subscriptionType.type == 1"
                          >Adresse MAG:
                          {{ request.subscriptionType.note }}</span
                        >
                      </div>
                    </div>
                    <!--end::Info-->
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="d-flex flex-wrap align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                    ></div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3"
                    >
                      <div class="text-dark-75 font-weight-bolder font-size-lg">
                        Date de création:
                      </div>
                    </div>
                    <!--end::Title-->
                    <!--begin::Info-->
                    <div class="d-flex align-items-center py-lg-0 py-2">
                      <div class="d-flex flex-column text-right">
                        <span
                          class="text-primary font-weight-bolder font-size-h6"
                          >{{
                            request.createdAtUtc | moment("DD/MM/YYYY HH:mm")
                          }}</span
                        >
                      </div>
                    </div>
                    <!--end::Info-->
                  </div>
                  <div class="separator separator-dashed mt-2 mb-2"></div>
                  <div class="d-flex flex-wrap align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                    ></div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3"
                    >
                      <div class="text-dark-75 font-weight-bolder font-size-lg">
                        Date fin d'abonnement:
                      </div>
                    </div>
                    <!--end::Title-->
                    <!--begin::Info-->
                    <div class="d-flex align-items-center py-lg-0 py-2">
                      <div class="d-flex flex-column text-right">
                        <span
                          class="text-primary font-weight-bolder font-size-h6"
                          >{{
                            request.endDateUtc | moment("DD/MM/YYYY HH:mm")
                          }}</span
                        >
                      </div>
                    </div>
                    <!--end::Info-->
                  </div>

                  <div class="separator separator-dashed mt-2 mb-2"></div>

                  <div class="d-flex flex-wrap align-items-center">
                    <!--begin::Symbol-->
                    <div
                      class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                    ></div>
                    <!--end::Symbol-->
                    <!--begin::Title-->
                    <div
                      class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3"
                    >
                      <div class="text-dark-75 font-weight-bolder font-size-lg">
                        Montant:
                      </div>
                    </div>
                    <!--end::Title-->
                    <!--begin::Info-->
                    <div class="d-flex align-items-center py-lg-0 py-2">
                      <div class="d-flex flex-column text-right">
                        <span
                          class="text-success font-weight-bolder font-size-h6"
                          v-if="request.amount"
                          >{{
                            Intl.NumberFormat("fr", {
                              style: "currency",
                              currency: "CAD",
                            }).format(request.amount)
                          }}</span
                        >
                        <span
                          class="text-muted font-weight-bolder font-size-h6"
                          style="text-decoration: line-through"
                          v-if="request.amount < request.amountWithoutPromotion"
                        >
                          {{
                            Intl.NumberFormat("fr", {
                              style: "currency",
                              currency: "CAD",
                            }).format(request.amountWithoutPromotion)
                          }}
                        </span>
                      </div>
                    </div>
                    <!--end::Info-->
                  </div>
                </div>
              </div>
            </div>
            <!--end::Body-->
          </div>
        </b-overlay>
      </div>
    </div>

    <b-modal
      id="cancel-modal"
      ref="cancel-modal"
      title="Annulation de la demande"
      size="lg"
      centered
    >
      <div class="form-group">
        <label for="exampleSelect1"
          >Motif <span class="text-danger">*</span></label
        >
        <select
          class="form-control"
          v-model="cancel.motiveGuid"
          :class="{ 'is-invalid': $v.cancel.motiveGuid.$error }"
        >
          <option value="6020d47a-1b48-41a8-825b-83f306c0a7ac">
            Le client est injoignable
          </option>
          <option value="3c1d738f-e10b-48b4-be0a-9d17afb55ac8">
            Le client a effectué un test
          </option>
          <option value="e0c18056-36ee-4961-9985-69e8cd78dacf">
            Tous nos infirmiers sont occupés, nous vous invitons à choisir une
            date ultérieure. Nous vous remercions pour votre compréhension.
          </option>
          <option value="9bf5d7bf-c5d8-4b77-801e-3d94b770950d">Autre</option>
        </select>
        <div v-if="$v.cancel.motiveGuid.$invalid" class="invalid-feedback">
          Champ obligatoire
        </div>
      </div>
      <div
        class="form-group mb-1"
        v-if="cancel.motiveGuid == '9bf5d7bf-c5d8-4b77-801e-3d94b770950d'"
      >
        <label for="exampleTextarea">Commentaire</label>
        <textarea
          class="form-control"
          rows="3"
          v-model="cancel.note"
        ></textarea>
      </div>

      <template v-slot:modal-footer>
        <b-overlay :show="isLoading" rounded="sm">
          <button type="button" class="btn btn-success" @click="cancelation()">
            Valider
          </button>
        </b-overlay>
        <button
          type="button"
          class="btn btn-secondary"
          @click="$bvModal.hide('cancel-modal')"
        >
          Fermer
        </button>
      </template>
    </b-modal>

    <b-modal
      id="subscription-activation-modal"
      ref="subscription-activation-modal"
      title="Activation"
      size="lg"
      centered
    >
      <div class="form-group row">
        <label class="col-5 col-form-label">Date début d'abonnement</label>
        <div class="col-7">
          <DxDateBox
            :value="request.startDateUtc"
            type="datetime"
            @value-changed="onReservationStartDateChanged"
            :date-serialization-format="dateSerializationFormat"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-5 col-form-label">Date fin d'abonnement</label>
        <div class="col-7">
          <DxDateBox
            :value="request.endDateUtc"
            type="datetime"
            @value-changed="onReservationEndDateChanged"
            :date-serialization-format="dateSerializationFormat"
          />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-5 col-form-label">Url</label>
        <div class="col-7">
          <input
            type="text"
            class="form-control"
            v-model="activation.url"
            :class="{ 'is-invalid': $v.activation.url.$error }"
          />
          <div v-if="$v.activation.url.$invalid" class="invalid-feedback">
            Champ obligatoire
          </div>
        </div>
      </div>

      <div class="form-group row" v-if="request.subscriptionType.type == 2">
        <label class="col-5 col-form-label">Nom d'utilisateur</label>
        <div class="col-7">
          <input
            type="text"
            class="form-control"
            v-model="activation.userName"
            :class="{ 'is-invalid': $v.activation.userName.$error }"
          />
          <div v-if="$v.activation.password.$invalid" class="invalid-feedback">
            Champ obligatoire
          </div>
        </div>
      </div>

      <div class="form-group row" v-if="request.subscriptionType.type == 2">
        <label class="col-5 col-form-label">Mot de passe</label>
        <div class="col-7">
          <input
            type="text"
            class="form-control"
            v-model="activation.password"
            :class="{ 'is-invalid': $v.activation.password.$error }"
          />
          <div v-if="$v.activation.password.$invalid" class="invalid-feedback">
            Champ obligatoire
          </div>
        </div>
      </div>
      
      <template v-slot:modal-footer>
        <b-overlay :show="isLoading" rounded="sm">
          <button
            type="button"
            class="btn btn-success"
            @click="subscriptionActivation()"
          >
            Valider
          </button>
        </b-overlay>
        <button
          type="button"
          class="btn btn-secondary"
          @click="$bvModal.hide('subscription-activation-modal')"
        >
          Fermer
        </button>
      </template>
    </b-modal>

    <b-modal
      id="change-subscription-end-date-modal"
      ref="change-subscription-end-date-modal"
      title="Date de fin d'abonnement"
      size="lg"
      centered
    >
 
      <div class="form-group row">
        <label class="col-5 col-form-label">Date début d'abonnement</label>
        <div class="col-7">
          <DxDateBox
            :value="editRequest.startDateUtc"
            type="datetime"
            @value-changed="onReservationStartDateChanged2"
            :date-serialization-format="dateSerializationFormat"
          />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-5 col-form-label">Date fin d'abonnement</label>
        <div class="col-7">
          <DxDateBox
            :value="editRequest.endDateUtc"
            type="datetime"
            @value-changed="onReservationEndDateChanged2"
            :date-serialization-format="dateSerializationFormat"
          />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-5 col-form-label">Url</label>
        <div class="col-7">
          <input
            type="text"
            class="form-control"
            v-model="editRequest.url"
            :class="{ 'is-invalid': $v.editRequest.url.$error }"
          />
          <div v-if="$v.editRequest.url.$invalid" class="invalid-feedback">
            Champ obligatoire
          </div>
        </div>
      </div>

      <div class="form-group row" v-if="request.subscriptionType.type == 2">
        <label class="col-5 col-form-label">Nom d'utilisateur</label>
        <div class="col-7">
          <input
            type="text"
            class="form-control"
            v-model="editRequest.userName"
            :class="{ 'is-invalid': $v.editRequest.userName.$error }"
          />
          <div v-if="$v.editRequest.password.$invalid" class="invalid-feedback">
            Champ obligatoire
          </div>
        </div>
      </div>

      <div class="form-group row" v-if="request.subscriptionType.type == 2">
        <label class="col-5 col-form-label">Mot de passe</label>
        <div class="col-7">
          <input
            type="text"
            class="form-control"
            v-model="editRequest.password"
            :class="{ 'is-invalid': $v.editRequest.password.$error }"
          />
          <div v-if="$v.editRequest.password.$invalid" class="invalid-feedback">
            Champ obligatoire
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-overlay :show="isLoading" rounded="sm">
          <button
            type="button"
            class="btn btn-success"
            @click="changeSubscriptionEndDate()"
          >
            Valider
          </button>
        </b-overlay>
        <button
          type="button"
          class="btn btn-secondary"
          @click="$bvModal.hide('change-subscription-end-date-modal')"
        >
          Fermer
        </button>
      </template>
    </b-modal>
  </div>
</template>

<style scoped>
.image {
  max-height: 300px;
  max-width: 300px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
.selected-data {
  margin-top: 20px;
  padding: 20px;
  background-color: rgba(191, 191, 191, 0.15);
}

.selected-data .caption {
  font-weight: bold;
  font-size: 115%;
  margin-right: 4px;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SELECT_NOTIFICATION } from "../../../core/services/store/notification.module";

import requestsService from "../../../services/requests.service";
import SweetAlert2 from "../../../helpers/sweetAlert2.helper";
//import SearchApiService from "../../../core/services/searchapi.service";
//import JwtService from "../../../core/services/jwt.service";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import DxDateBox from "devextreme-vue/date-box";

export default {
  mixins: [validationMixin],
  name: "detail",
  components: {
    DxDateBox,
  },
  data() {
    return {
      dateSerializationFormat: "yyyy-MM-ddTHH:mm:ssZ",
      activation: {},
      quote: {},
      cancel: {},
      result: {},

      request: {
        service: {},
        subService: {},
        requestedBy: {},
        subscriptionState: {},
        subscriptionType: {},
      },
      editRequest: {},
      selectedSubscriptionStartDateUtc: null,
      selectedSubscriptionEndDateUtc: null,
      isLoading: false,
    };
  },
  validations: {
    quote: {
      amount: {
        required,
      },
    },
    cancel: {
      motiveGuid: {
        required,
      },
    },
    result: {
      link: {
        required,
      },
    },
    activation: {
      userName: {
        required,
      },
      password: {
        required,
      },
      url: {
        required,
      },
    },
    editRequest: {
      userName: {
        required,
      },
      password: {
        required,
      },
      url: {
        required,
      },
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.getRequest(to.params.guid);
    next();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Demandes" },
      { title: "Detail" },
    ]);
    this.$store.dispatch(SELECT_NOTIFICATION, this.$route.params.guid);

    this.getRequest(this.$route.params.guid);
  },
  methods: {
    getRequest: function(guid) {
      this.isLoading = true;
      requestsService
        .getRequest(guid)
        .then((result) => {
          this.request = result.data;
          this.request.startDateUtc =  this.request.startDateUtc ?? new Date();
          this.selectedSubscriptionStartDateUtc = this.request.startDateUtc;
          this.selectedSubscriptionEndDateUtc = this.request.endDateUtc;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });

      requestsService.getRequestCount();
    },

    getRequestStateLable: function(state) {
      return requestsService.getRequestStateLable(state);
    },

    cancelation: function() {
      this.$v.cancel.$touch();
      if (this.$v.cancel.$anyError) {
        return;
      }

      SweetAlert2.question(
        "Confirmation",
        "Voulez-vouz effectuer cette opération ?"
      ).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          requestsService
            .cancelRequest({
              requestGuid: this.request.guid,
              motiveGuid: this.cancel.motiveGuid,
              note: this.cancel.note,
            })
            .then(() => {
              SweetAlert2.success("L'opération a réussi", "");
              this.getRequest(this.request.guid);
              this.isLoading = false;
              this.$bvModal.hide("cancel-modal");
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    onReservationStartDateChanged(e) {
      this.selectedSubscriptionStartDateUtc = e.value;
    },
    onReservationStartDateChanged2(e) {
      this.selectedSubscriptionStartDateUtc = e.value;
    },
    onReservationEndDateChanged(e) {
      this.selectedSubscriptionEndDateUtc = e.value;
    },
    onReservationEndDateChanged2(e) {
      this.selectedSubscriptionEndDateUtc = e.value;
    },
    startChangeSubscriptionEndDate: function() {
      this.$bvModal.show("change-subscription-end-date-modal");
      this.editRequest = {
        userName: this.request.subscriptionType.userName,
        password: this.request.subscriptionType.password,
        url: this.request.subscriptionType.url,
        ...this.request
      }

    },
    changeSubscriptionEndDate: function() {
      SweetAlert2.question(
        "Confirmation",
        "Voulez-vouz modifier cet abonnement ?."
      ).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          requestsService
            .changeSubscriptionEndDate({
              subscriptionGuid: this.request.guid,
              userName: this.editRequest.userName,
              password: this.editRequest.password,
              url: this.editRequest.url,
              subscriptionStartDateUtc: this.selectedSubscriptionStartDateUtc,
              subscriptionEndDateUtc: this.selectedSubscriptionEndDateUtc,  
            })
            .then(() => {
              this.isLoading = false;
              SweetAlert2.success("L'opération a réussi", "");
              this.getRequest(this.request.guid);
              this.$bvModal.hide("change-subscription-end-date-modal");
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    startSubscriptionActivation: function() {
      if (this.request.subscriptionType.type == 2) {
        this.activation = {
          userName: this.request.subscriptionType.userName,
          password: this.request.subscriptionType.password,
          url : this.request.subscriptionType.url,
        };
      }

      this.$bvModal.show("subscription-activation-modal");
    },
    subscriptionActivation: function() {
      if (this.selectedSubscriptionEndDateUtc == null || this.selectedSubscriptionEndDateUtc == null) {
        SweetAlert2.warning("Alerte", "Selectionner une date.");
        return;
      }

      if (this.request.subscriptionType.type == 2) {
        this.$v.activation.$touch();
        if (this.$v.activation.$anyError) {
          return;
        }
      }
      SweetAlert2.question(
        "Confirmation",
        "Voulez-vouz activer cet abonnement ?."
      ).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          requestsService
            .activateSubscription({
              subscriptionGuid: this.request.guid,
              userName: this.activation.userName,
              password: this.activation.password,
              url: this.activation.url,
              subscriptionStartDateUtc: this.selectedSubscriptionStartDateUtc,
              subscriptionEndDateUtc: this.selectedSubscriptionEndDateUtc,             
            })
            .then(() => {
              this.activation = {};
              this.isLoading = false;
              SweetAlert2.success("L'opération a réussi", "");
              this.getRequest(this.request.guid);
              this.$bvModal.hide("subscription-activation-modal");
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },

    goToRequestDetail(guid) {
      this.$router.push({
        name: "requests-detai-requestdetail",
        params: { guid: guid },
      });
    },
    goToStateHistory(guid) {
      this.$router.push({
        name: "requests-detai-statehistory",
        params: { guid: guid },
      });
    },
    goToClient(guid) {
      this.$router.push({
        name: "clients-detail",
        params: { guid: guid },
      });
    },
    goToPartner(guid) {
      this.$router.push({
        name: "partners-detail",
        params: { guid: guid },
      });
    },
  },
};
</script>
